require('./expensesByCategoryTabs.scss');
require('./expensesByCategoryTabsBlock.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');
const classNames = require('classnames');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @common
const ComparativeBar = require('components/commons/comparativeBar/comparativeBar');
const OKCarousel = require('components/commons/OKCarousel/OKCarousel');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @helpers
const { getFirstNChars } = require('utilities/stringHelper');
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { getCategoryIcon } = require('constants/categories');

// @images
const openTutorialImg = require('assets/images/icon-tutorial.svg');

class ExpensesByCategoryTabs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentSlider: 0
        };

        this.handleNext = this.handleNext.bind(this)
        this.handlePrevious = this.handlePrevious.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const firsTab = nextProps.categories.indexOf(nextProps.selectedTab);
        this.setState({ currentSlider: firsTab });
    }

    handleNext() {
        this.slider.slickNext()
    }

    handlePrevious() {
        this.slider.slickPrev()
    }

    handleCategoryChange(category) {
        this.props.onChangeCategory(category);
    }

    getBlocks(categories) {
        const { totalExpenses, totalCategoryExpenses, selectedTab, blue } = this.props;

        return(
            categories.map((item, index) => {

                const finalBlockClass = classNames('expenses-by-category-tabs-block', {
                    'expenses-by-category-tabs-block--selected': item === selectedTab
                });

                const iconClasses = classNames(
                    'expenses-by-category-tabs-block__icon',
                    getCategoryIcon(item)
                );

                let categoryName = formatText('categories-'+item);
                let categoryNameLimit = 18;
                let categoryNameContent = (
                    <span className="expenses-by-category-tabs-block__category-name">
                        {categoryName}
                    </span>
                )
                let toolTipContent = (
                    <span>
                        {categoryName}
                    </span>
                );
                if (categoryName.length > categoryNameLimit) {
                    categoryName = getFirstNChars(categoryName, categoryNameLimit);
                    categoryNameContent = (<OKTooltip
                        content={toolTipContent}
                        offset={[0, -15]}
                        target={categoryNameContent}
                    />)
                }
                const expenses = totalCategoryExpenses ? totalCategoryExpenses.get(item) : 0;

                return(
                    <div key={index} className={finalBlockClass} onClick={() => this.handleCategoryChange(item)}>
                        <div className="expenses-by-category-tabs-block__category-name-wrapper">
                            <i className={iconClasses} />
                            {categoryNameContent}
                        </div>
                        <div className="expenses-by-category-tabs-block__bar-wrapper">
                            <ComparativeBar
                                slim
                                blueBar={blue}
                                firstValue={expenses}
                                totalValue={totalExpenses}
                                className="expenses-by-category-tabs-block__bar"
                            />
                        </div>
                    </div>
                );
            })
        );
    }

    render() {
        const { categories } = this.props;
        const { currentSlider } = this.state;
        const blocks = this.getBlocks(categories);
        const tabsPerClick = 5;
        const tooltipTarget = (
            <img
                src={openTutorialImg}
                className="expenses-by-category-tabs__tooltip-element"
            />
        );

        const settings = {
            className: 'expenses-by-category-tabs__carousel',
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: tabsPerClick,
            slidesToScroll: tabsPerClick,
            draggable: false,
            arrows: false,
            initialSlide: currentSlider
        };

        return (
            <div className="expenses-by-category-tabs">
                <div className="expenses-by-category-tabs__box-title">
                    <h3 className="expenses-by-category-tabs__title">
                        <FormattedText value="accountMovements-movementsTitle" />
                        <OKTooltip
                            content="globalPositionExpenses-expensesByCategoryTooltip"
                            offset={[15, 0]}
                            placement="right"
                            target={tooltipTarget}
                        />
                    </h3>
                </div>
                <div>
                    <OKCarousel
                        numberSlides={this.props.categories.length}
                        settings={settings}
                        blocks={blocks}
                        leftButtonClass="expenses-by-category-tabs__left-button"
                        rightButtonClass="expenses-by-category-tabs__right-button"
                        leftIcon="icon-breadcrumb"
                        rightIcon="icon-breadcrumb"
                        customInitial
                    />
                </div>
            </div>
        );
    }
}

ExpensesByCategoryTabs.propTypes = {
    categories: PropTypes.array,
    onChangeCategory: PropTypes.func,
    totalExpenses: PropTypes.number,
    totalCategoryExpenses: PropTypes.object,
    selectedTab: PropTypes.string,
    blue: PropTypes.bool
}

module.exports = ExpensesByCategoryTabs;
